import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Java Foundations & Programming Essentials",
    description:
      "Introduction to Java features & use cases, JVM JRE & JDK architecture, Writing compiling & executing Java programs, Variables data types operators, Input/output operations & coding structure",
  },
  {
    title: "Control Statements, Loops & Logical Building",
    description:
      "Decision-making: if else switch, For while & do-while loops, Break continue & nested structures, Logical programming exercises, Real-world condition-based scenarios",
  },
  {
    title: "Object-Oriented Programming (OOP) in Java",
    description:
      "Classes objects & constructors, Inheritance polymorphism abstraction & encapsulation, Method overloading & overriding, Access modifiers & packages, Designing reusable & modular code",
  },
  {
    title: "Arrays, Strings & Collections Framework",
    description:
      "Single/multi-dimensional arrays, String handling & string methods, Wrapper classes & autoboxing, Collections: List Set Map, Iterators generics & data structure usage",
  },
  {
    title: "Exception Handling & Debugging Techniques",
    description:
      "Types of exceptions, Try-catch-finally & throw/throws, Custom exceptions, Error handling best practices, Debugging using IDE tools",
  },
  {
    title: "File Handling, Input-Output & Serialization",
    description:
      "Reading & writing files, Byte streams & character streams, Object serialization & deserialization, Directory operations, Real-world file-based project",
  },
  {
    title: "Java GUI Development & Event Handling (Swing/JavaFX)",
    description:
      "Introduction to GUI frameworks, Creating windows forms & controls, Event-driven programming, Designing simple desktop applications, Optional: JavaFX for advanced UI",
  },
  {
    title: "Multithreading, Concurrency & Performance Optimization",
    description:
      "Thread lifecycle & creation, Synchronization & inter-thread communication, Executor framework, Concurrent collections, Building high-performance applications",
  },
  {
    title: "JDBC, Database Connectivity & Backend Development",
    description:
      "Introduction to SQL & databases, Connecting Java apps with MySQL/PostgreSQL, CRUD operations using JDBC, Prepared statements & transactions, Designing backend modules with Java",
  },
  {
    title: "Capstone Java Project & Career Launchpad",
    description:
      "End-to-end Java application development, Database integration + UI/backend workflow, GitHub portfolio creation, Resume building for Java Developer roles, Interview prep for Core Java OOPs & backend roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
